"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactApollo = require("react-apollo");
var _reactRouter = require("react-router");
var _commonLoader = require("@mmc/common-loader");
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _calculationForm = _interopRequireDefault(require("./calculation-form"));
var _calculationForm2 = _interopRequireDefault(require("./calculation-form2"));
var _query = require("./query");
var _calculationForm3 = require("./calculation-form.utils");
var _commonSetLocation = require("@mmc/common-set-location");
var _commonLibs = require("@mmc/common-libs");
var _CommonLoader;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CalculatorFormResolver = function CalculatorFormResolver(props) {
  var market = props.market,
    language = props.language,
    dataProp = props.data,
    _props$location$query = props.location.query,
    vehicle = _props$location$query.vehicle,
    paymentVehicle = _props$location$query.paymentVehicle,
    yearParam = _props$location$query.year,
    isBackgroundWhite = props.isBackgroundWhite;
  var _useState = (0, _react.useState)({
      zipCode: ''
    }),
    state = _useState[0],
    setState = _useState[1];
  (0, _react.useEffect)(function () {
    var cachedLocation = (0, _commonSetLocation.getCachedLocation)();
    if (cachedLocation && cachedLocation != null && cachedLocation.stateCode) {
      var code = {
        zipCode: cachedLocation == null ? void 0 : cachedLocation.stateCode
      };
      setState(_objectSpread(_objectSpread({}, state), code));
    }
    _commonLibs.EventEmitter.subscribe('locationChangeEvent', function (data) {
      var stateCode = data.stateCode;
      if (stateCode) {
        var _code = {
          zipCode: stateCode
        };
        setState(_objectSpread(_objectSpread({}, state), _code));
      }
    });
  }, []);

  // Resolve Calculator v2
  if (market === 'ca') {
    // Make sure a vehicle has been selected, either on OGC/NGC or Payment Calculator
    if (!vehicle && !paymentVehicle) {
      return null;
    }

    // OGC compatible: Make sure ContentPage with `vehicles` is pulled
    var data = null;
    if (!dataProp) {
      var year = yearParam && Number(yearParam);
      var _useQuery = (0, _reactApollo.useQuery)(_query.PC_CONTENT_PAGE_QUERY_V2, {
          variables: _objectSpread(_objectSpread(_objectSpread({
            market: market,
            lang: language,
            // FIXME: Replace harcoded value with expected `path`
            path: language === 'en' ? '/content/mitsubishi-motors/ca/en/buy/payment-calculator' : '/content/mitsubishi-motors/ca/fr/acheter/calculateur-de-paiements'
          }, vehicle && {
            paymentVehicle: vehicle
          }), year && {
            paymentYear: year
          }), {}, {
            zipCode: state.zipCode
          })
        }),
        rawData = _useQuery.data,
        loading = _useQuery.loading;
      if (loading) {
        return _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null));
      }
      if (rawData) {
        data = (0, _calculationForm3.getComponentPageDataByResourceType)(rawData, CalculatorFormResolver.resourceType());
      }
    }
    return /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, {
      skip: true
    }, /*#__PURE__*/_react["default"].createElement(_calculationForm2["default"], (0, _extends2["default"])({
      data: data
    }, props, {
      isBackgroundWhite: isBackgroundWhite
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_calculationForm["default"], props);
};
CalculatorFormResolver.displayName = 'CalculationForm';
CalculatorFormResolver.resourceType = function () {
  return 'PaymentCalculator_1_0_0';
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language,
    path: props.path || state.Config.path
  };
};
var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(CalculatorFormResolver));
exports["default"] = _default;